<template>
  <div>
    <el-row>
      <el-col :span="8">
        <div hideTitle>
          <VersionIcon @click="handleClick"
                      height="120px"
                      width="120px"
          ></VersionIcon>
        </div>
      </el-col>
      <el-col :span="16">
        <div hideTitle style="font-size: 14px;">
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">版本标识: </span>
            <span style="color: #000000">{{ value.cliDefn }}</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">版本编号: </span>
            <span style="color: #000000">{{ value.cliVersion }}</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">加密设备类型: </span>
            <span style="color: #000000">{{ value.cliEncryType }}</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">通知人员名称: </span>
            <span style="color: #000000">{{ value.cliNoticName }}</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">通知人员邮件地址: </span>
            <span style="color: #000000">{{ value.cliNoticEmail }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import VersionIcon from "./VersionIcon.vue";
  import EasyConfigApi from "@/api/basics/EasyConfigApi";

  export default {
    components: {VersionIcon},
    data() {
      return {
        value: Object,
      };
    },
    mounted() {
      this.query();
    },
    watch: {},
    methods: {
      query() {
        EasyConfigApi.doGetBaseInfo().then(resp => {
          this.value = resp.baseinfo;
        })
      }
    }
  };
</script>
<style>
</style>

